export function maxNumbersAfterDecimalValidation(number?: number) {
  if (number === undefined) {
    return true;
  }
  return /^\d+(\.\d{0,5})?$/.test(number.toString());
}
